/* global toastr */

import React from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

import { request } from '../lib/utils'
import { store } from '../../index'
import { Paginator, Tooltip } from '../lib/components'
import { BaseBpsView } from './base_view'
import { format_attr_value } from '../lib/utils'
import { ModalOrderColumn } from './components/modal_order_column'


export class BaseListView extends BaseBpsView {

  constructor(props) {
    super(props)

    this.updateItemsProcess = false

    this.onSearch = this.onSearch.bind(this)
    this.updateItems = this.updateItems.bind(this)
    this.downloadReestr = this.downloadReestr.bind(this)
  }

  onSearch(data) {
    store.dispatch({ type: `${this.project_name}_search`, data })
    this.setState({ preset_counters: {}, hasPresetOpen: undefined })
  }

  updateItems(page_num, notify_end) {
    const that = this

    request({
      method: 'post',
      url: `/api/${this.project_name}/get_page`,
      data: {
        page_num: page_num,
        filter_data: this.props.search_data || {},
        preset: this.props.search_preset || "",
        order_attr_name: this.props.order_attr_name,
        order_direction: this.props.order_direction,
      },
      success: (data) => {
        that.waitRenderReadyLock = false
        if (notify_end)
          toastr.info('Данные обновлены')
        store.dispatch({
          type: `${that.project_name}_list_change`,
          data: { ...data, page: page_num },
        })
      },
      error: (data) => {
        toastr.error(data.detail, "Ошибка обновления")
        that.waitRenderReadyLock = false
      },
    })
  }

  renderBreadcrumbs() {
    return (
      <nav>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/">Домой</Link>
          </li>
          <li className="breadcrumb-item active">{this.props.project_title}</li>
        </ol>
      </nav>
    )
  }

  getTopPanelLeftactions() {
    let actions = []

    actions.push(<li key="downloadReestr">
      <a className="dropdown-item" onClick={() => { this.downloadReestr("") }} key="downloadReestr">
        <i className="ti ti-download ti-xs me-1"></i>
        <span className="d-none d-md-inline-block">Скачать</span>
      </a>
    </li>)

    actions.push(<li key="modal_order_column">
      <a className="dropdown-item" data-bs-toggle="modal" data-bs-target="#modal_order_column" key="order_column">
        <i className="ti ti-columns-3 ti-xs me-1"></i>
        <span className="d-none d-md-inline-block">Настроить колонки</span>
      </a>
    </li>)

    return actions
  }

  downloadReestr(profile) {
    const that = this

    request({
      method: 'post',
      url: `/api/${this.project_name}/download_reestr`,
      data: {
        filter_data: this.props.search_data || {},
        preset: this.props.search_preset || "",
        profile: profile,
      },
      success: (data) => {
        toastr.info(`Выгрузка добавлена в очередь на выполнение. После завершения, мы отправим письмо на адрес ${that.user.email}`)
      },
    })
  }

  waitRenderReady() {
    const dummyContent = super.waitRenderReady()
    if (dummyContent !== undefined) {
      return dummyContent
    }

    // Мета-данные проекта не пришли
    if (!this.props.project_title) {
      this.waitRenderReadyLock = true
      this.initMeta()
      return <div>Загрузка мета-данных...</div>
    }

    // Пока список с объектами не пришел, выходим и ждем его
    if (this.props.list_items === undefined) {
      this.waitRenderReadyLock = true
      this.updateItems(this.props.list_page)
      return <div>Загрузка документов...</div>
    }
  }

  renderTrTd(row, attr_name, idx) {
    const attr = this.props.attrs[attr_name]
      let content = format_attr_value(attr, row[attr_name]) || "---"

      // Первая колонка со ссылкой всегда
      if (idx === 0) {
        const td_class = row.message ? `text-${row.message.class}` : undefined

        content = <div className="text-nowrap">
          <Link to={`/${this.project_name}/${row.id}/`} className="me-1">
            {content}
          </Link>
          {row.message && <Tooltip message={row.message.text} class_name={td_class} />}
        </div>
      }
      else {
        content = format_attr_value(attr, row[attr_name]) || "---"
      }

      return <td key={attr_name}>{content}</td>
  }

  renderContent() {
    const table_headers_ordered = this.props.table_headers_ordered
    const table_headers = this.props.user_table_headers || this.props.table_headers
    const order_attr_name = this.props.order_attr_name
    const order_direction = this.props.order_direction

    const renderTh = (attr_name) => {
      const attr = this.props.attrs[attr_name]
      let order_icon = undefined

      // Если эта колонка сортируемая, формируем иконку для сортировки и обработчик нажатия на нее
      if (table_headers_ordered && table_headers_ordered.includes(attr_name)) {
        const attr_order_direction = order_attr_name == attr_name ? order_direction : undefined

        const order_icon_class = classNames("ms-1 text-muted pointer ti", {
          "ti-arrow-narrow-down": attr_order_direction === "asc",
          "ti-arrow-narrow-up": attr_order_direction === "desc",
          "ti-arrows-sort": attr_order_direction === undefined,
        })

        const changeOrder = () => {
          const new_order_direction = { undefined: "asc", "asc": "desc", "desc": undefined }[order_direction]

          store.dispatch({
            type: `${this.project_name}_set_order`,
            data: {
              order_attr_name: new_order_direction ? attr_name : undefined,
              order_direction: new_order_direction
            }
          })
        }

        order_icon = <span className={order_icon_class} onClick={changeOrder}></span>
      }

      return <th key={attr_name}>
        {attr.title}
        {order_icon}
      </th>
    }

    const renderTr = (row) => {
      const tr_class = row.message ? `table-${row.message.class}` : undefined

      return <tr key={row.id} className={tr_class}>
        {table_headers.map((attr_name, idx) => { return this.renderTrTd(row, attr_name, idx) })}
      </tr>
    }

    if (this.props.list_items.length === 0) {
      return <div className="card mb-3">
        <div className="card-body p-3">
          Данные не найдены. Уточните условия отбора и поиска.
        </div>
      </div>
    }

    return [
      <div className="card mb-3">
        <div className="table-responsive pb-3">
          <table className='table table-sm'>
            <thead><tr>
              {table_headers.map(renderTh)}
            </tr></thead>
            <tbody className="table-border-bottom-0 text-nowrap">
              {this.props.list_items.map(renderTr)}
            </tbody>
          </table>
        </div>
      </div>,

      <Paginator current_page={this.props.list_page}
        count_pages={this.props.list_count_pages}
        has_next={this.props.list_has_next_page}
        setPage={this.updateItems} />
    ]
  }

  renderModals() {
    let modals = [super.renderModals()]

    modals.push(<ModalOrderColumn project_name={this.project_name}
      attrs={this.props.attrs}
      table_headers={this.props.table_headers}
      user_table_headers={this.props.user_table_headers} />)

    return modals
  }

}
